module.exports = __webpack_public_path__ + "img/bg_index_teacher_01_new.9a531c1e.png";